import * as React from 'react'

function ChipIcon (props)
{
	const output =
	(
		<svg xmlns="http://www.w3.org/2000/svg" width={ 1024 } height={ 1024 }
			viewBox="0 0 1024 1024" { ...props }>
			<title>Puce de carte bancaire</title>
			<path fill="currentColor" d="M731.428 621.714h292.572v146.285h-292.572z" />
			<path fill="currentColor" d="M731.428 438.857h292.572v146.285h-292.572z" />
			<path fill="currentColor" d="M731.428 896h182.857c54.071-0.104 98.965-39.267 107.973-90.77l0.095-0.658h-290.926z" />
			<path fill="currentColor" d="M292.572 896v-91.428h-290.926c9.104 52.162 53.998 91.325 108.058 91.428h0.011z" />
			<path fill="currentColor" d="M0 256.001h292.572v146.285h-292.572z" />
			<path fill="currentColor" d="M0 438.857h292.572v146.285h-292.572z" />
			<path fill="currentColor" d="M0 621.714h292.572v146.285h-292.572z" />
			<path fill="currentColor" d="M292.572 219.428v-91.428h-182.857c-54.071 0.104-98.965 39.267-107.973 90.77l-0.095 0.658z" />
			<path fill="currentColor" d="M329.143 128v768h365.714v-457.143c0-20.197 16.374-36.571 36.571-36.571v0h292.572v-146.285h-292.572c-20.197 0-36.571-16.374-36.571-36.571v0-91.428z" />
			<path fill="currentColor" d="M914.286 128h-182.857v91.428h290.926c-9.104-52.162-53.998-91.325-108.058-91.428h-0.011z" />
		</svg>
	);

	return output;
}

export default ChipIcon
